import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { useExperimentEnabled } from "@/react/hooks/experiments/useExperimentEnabled";

const localeRoot =
  "authentication_app.questions.form.april_2025_questions.options";

const ELIGIBLE_ACHIEVE_OPTIONS = [
  t(`${localeRoot}.achieve_with_circle.build_new_community`),
  t(`${localeRoot}.achieve_with_circle.migrate_to_circle`),
];
const ELIGIBLE_REVENUE_STAGES = [
  t(`${localeRoot}.customer_journey_stage.over_250k`),
  t(`${localeRoot}.customer_journey_stage.100_250k`),
  t(`${localeRoot}.customer_journey_stage.50_100k`),
];

export const useCommunityEligibleForPlusLead = (): boolean => {
  const { currentCommunity } = usePunditUserContext();

  // This will be removed after we confirm the experiment is working in production
  const isPlusLeadExperimentEnabled = useExperimentEnabled(
    "plus_lead_experiment",
  );

  if (!currentCommunity?.sign_up_flow_responses) {
    return false;
  }

  if (!isPlusLeadExperimentEnabled) {
    return false;
  }

  const { achieve_with_circle, customer_journey_stage } =
    currentCommunity.sign_up_flow_responses;

  const hasEligibleAchieveGoal =
    achieve_with_circle &&
    ELIGIBLE_ACHIEVE_OPTIONS.includes(achieve_with_circle);

  const hasEligibleRevenueStage =
    customer_journey_stage &&
    ELIGIBLE_REVENUE_STAGES.includes(customer_journey_stage);

  return Boolean(hasEligibleAchieveGoal && hasEligibleRevenueStage);
};
